import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export type DisabledSurfaceOverlayProps = {
  label: ReactNode
  bordered?: boolean
}

export function DisabledSurfaceOverlay({ label, bordered = false }: DisabledSurfaceOverlayProps) {
  return (
    <div
      data-slot="disabled-surface-overlay"
      data-bordered={bordered ? '' : undefined}
      className={cn(
        'absolute inset-0 z-20 flex items-start justify-end rounded-[inherit] bg-background/72 p-3 backdrop-blur-[1px]',
        bordered && 'ring-1 ring-inset ring-border/50'
      )}
    >
      <Badge variant="muted" size="sm">
        {label}
      </Badge>
    </div>
  )
}
